var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('line-chart-v2',{attrs:{"width":650,"height":400,"dataSet":_vm.data,"labels":_vm.labels,"labelX":_vm.labelX,"labelY":_vm.labelY,"borderColor":_vm.ChartConfig.color.primary,"label":_vm.label}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }